import { useState } from "react";
import { Redirect, useNavigate } from "react-router-dom";

import UserProfilePic from "../assets/images/user-profile.png";

import "./UserProfile.scss";
import AlertDialog from "./GeneralComponents/AlertDialog";

export const UserProfile = () => {
  const [showAlert, setShowAlert] = useState(false);

  // useEffect(() => {
  //     // get theme from windows theme or mobile theme
  //     const windowsOrMobileIsDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches
  //     const isDarkMode = localStorage.getItem('AppInDarkMode') === null ?
  //         windowsOrMobileIsDarkMode :
  //         JSON.parse(localStorage.getItem('AppInDarkMode'))
  //     setAppInDarkMode(isDarkMode)
  // }, []);

  // const [AppInDarkMode, setAppInDarkMode] = useState(false)
  const navigate = useNavigate();
  const logOut = async () => {
    // e.preventDefault();
    try {
      await localStorage.removeItem("token");
      await localStorage.removeItem("name");
      localStorage.removeItem("post");
      navigate("/login");
    } catch {
      alert(
        "عملیات انجام نشد، مجددا تلاش نمایید، در صورت تکرار خطا تمام اطلاعات برنامه را پاک نمایید"
      );
    }
  };

  const clearStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  // const changeAppTheme = () => {
  //     setAppInDarkMode(!AppInDarkMode)
  //     localStorage.setItem('AppInDarkMode', !AppInDarkMode)
  // }

  return (
    <div className="d-flex align-items-center flex-column position-relative TabBar-container">
      {localStorage.getItem("token") ? null : navigate("/")}

      <img
        className="user-profile-pic"
        src={UserProfilePic}
        alt="user-profile"
      />
      <p dir="rtl" style={{ margin: 10 }}>
        {localStorage.getItem("name")}
      </p>
      <p className="user-profile" dir="rtl" style={{ margin: 10 }}>
        <span>سمت شما:</span>
        <span>{localStorage.getItem("post")}</span>
      </p>

      <div className="button-version-container">
        <button className="custom-button-danger" onClick={() => logOut()}>
          خروج از حساب کاربری
        </button>
        <button
          className="custom-button-danger mt-3"
          onClick={() => setShowAlert(true)}
        >
          حذف تمام اطلاعات برنامه
        </button>
        {/* <button onClick={() => changeAppTheme()}>{AppInDarkMode ? "تغییر به روشن" : "تغیر به تیره"}</button>
                <h1>{AppInDarkMode ? "dark mode" : "light mode"}</h1> */}
        <div className="app-version mt-2">
          <p>
            v<span>2.2.30</span>
          </p>
        </div>
      </div>
      <AlertDialog
        showAlert={showAlert}
        title="حذف تمام اطلاعات برنامه"
        description="با حذف تمام اطلاعات برنامه، شما نیاز به ورود مجدد به برنامه دارید و همچنین تمام پروژه های پیش نویس شده و پروژه های ذخیره شده برای حالت آفلاین نیز حذف میگردند"
        acceptButtonText="خروج"
        rejectButtonText="انصراف"
        acceptButtonFunction={() => clearStorage()}
        rejectButtonFunction={() => setShowAlert(false)}
      />
    </div>
  );
};
export default UserProfile;
